export default __webpack_public_path__ + "static/media/b.d5823cac.svg";